import {List, ListItem, ListItemText, Typography} from '@mui/material';

export interface SubscriptionPlanFeatureProps {
  features: string[];
}

export default function SubscriptionPlanFeature({features}: SubscriptionPlanFeatureProps) {
  if (features.length === 0) {
    return null;
  }
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Features:
      </Typography>
      <List>
        {features.map((feature, index) => (
          <ListItem key={`SubscriptionPlan-${feature}`} divider={index !== features.length - 1}>
            <ListItemText primary={feature} />
          </ListItem>
        ))}
      </List>
    </>
  );
}
